import ModalLayout from "../../layout/ModalLayout.tsx";
import DeployForm from "../formik/DeployModalForm.tsx";

export type ModalType = {
    show: boolean;
    onClose: () => void;
    data?: any
};
export default function DeployModal({show, onClose, data}: ModalType) {
    return (
        <>
            {show && (
                <ModalLayout
                    title={"Repo Name"}
                    
                    onClose={onClose}
                >
                    <DeployForm onClose={onClose} />
                </ModalLayout>
            )}
        </>
    );
}
